import { render } from "./SpeakerDetailDialog.vue?vue&type=template&id=5ef7bbe3&scoped=true&ts=true"
import script from "./SpeakerDetailDialog.vue?vue&type=script&lang=ts"
export * from "./SpeakerDetailDialog.vue?vue&type=script&lang=ts"

import "./SpeakerDetailDialog.vue?vue&type=style&index=0&id=5ef7bbe3&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\program-list-inh26\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef7bbe3"]])

export default __exports__